let itemsData = [{
  "sku_id": 1000271,
  "title": "无源电子锁",
  "sub_title": "适用于各自箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-GS-1',
  "ali_images": [
    {'image':require('@/assets/img/products/guaLock/挂锁.gif')},
    {'image':require('@/assets/img/products/guaLock/挂锁.jpg')},
    {'image':require('@/assets/img/products/guaLock/挂锁图纸.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ]
//,'pdf_url':'CCPT电子锁_detail.pdf'
},
{
  "sku_id": 1000272,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-DL-1',
  "ali_images": [
  {'image':require('@/assets/img/products/psLock/rectangle/rectangle01.jpg')},
  {'image':require('@/assets/img/products/psLock/rectangle/rectangle04.jpg')},
    {'image':require('@/assets/img/products/psLock/rectangle/rectangle03.jpg')},
    {'image':require('@/assets/img/products/psLock/rectangle/rectangle06.jpg')},
    {'image':require('@/assets/img/products/psLock/rectangle/rectangle07.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ]
//,'pdf_url':'CCPT电子锁_detail.pdf'
},
{
  "sku_id": 1000273,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-3C-2',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/circle/circleLock1.jpg')},
    {'image':require('@/assets/img/products/psLock/circle/circleLock2.jpg')},
    {'image':require('@/assets/img/products/psLock/circle/circleLock3.jpg')},
    {'image':require('@/assets/img/products/psLock/circle/circleLock4.jpg')},
    {'image':require('@/assets/img/products/psLock/circle/circleLock6.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ]
//,'pdf_url':'CCPT电子锁_detail.pdf'
},
{
  "sku_id": 1000274,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG712-2',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/712/712-2.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ]
//,'pdf_url':'CCPT电子锁_detail.pdf'
},

{
  "sku_id": 1000275,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-856-1',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/865/865-1.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ]
//,'pdf_url':'CCPT电子锁_detail.pdf'
},
{
  "sku_id": 1000276,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-712-1',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/m712/712-2.jpg')},

  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ],
 'pdf_url':''
},
{
  "sku_id": 1000277,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-CL-1',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/3c/3c1.png')},
    {'image':require('@/assets/img/products/psLock/3c/3c.jpg')},
  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ],
 'pdf_url':''
},
{
  "sku_id": 1000278,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-CCPT-1',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/ccpt/ccpt1.jpg')},
    {'image':require('@/assets/img/products/psLock/ccpt/ccpt2.jpg')},
    {'image':require('@/assets/img/products/psLock/ccpt/ccpv.jpg')},
    {'image':require('@/assets/img/products/psLock/ccpt/ccpv2.jpg')},
  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ],
 'pdf_url':''
},
{
  "sku_id": 1000279,
  "title": "无源电子锁",
  "sub_title": "适用于电力箱体柜",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-840-2',
  "ali_images": [
    {'image':require('@/assets/img/products/psLock/840/840-1.jpg')},
//  {'image':require('@/assets/img/products/psLock/840/840-11.jpg')},
  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合室内室外使用',
    '锌合金外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ],
 'pdf_url':''
},
]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/passiveLockDetailData.js